var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 21H13V13H21V21ZM10 22V12C10 10.8954 10.8954 10 12 10H22C23.1046 10 24 10.8954 24 12V22C24 23.1046 23.1046 24 22 24H12C10.8954 24 10 23.1046 10 22ZM39 21H31V13H39V21ZM28 22V12C28 10.8954 28.8954 10 30 10H40C41.1046 10 42 10.8954 42 12V22C42 23.1046 41.1046 24 40 24H30C28.8954 24 28 23.1046 28 22ZM13 39H21V31H13V39ZM10 30V40C10 41.1046 10.8954 42 12 42H22C23.1046 42 24 41.1046 24 40V30C24 28.8954 23.1046 28 22 28H12C10.8954 28 10 28.8954 10 30ZM39 39H31V31H39V39ZM28 40V30C28 28.8954 28.8954 28 30 28H40C41.1046 28 42 28.8954 42 30V40C42 41.1046 41.1046 42 40 42H30C28.8954 42 28 41.1046 28 40Z",
    fill: "#13BD7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewGrid);
export default __webpack_public_path__ + "static/media/view-grid.94a3de204b40ffbd788be02501933285.svg";
export { ForwardRef as ReactComponent };